import type { Faq } from "@/data/faq";

export const proFaqs: Faq[] = [
  {
    question: "Why is ReelMatch Pro cheaper on the website?",
    answer:
      "App stores take a commission on in-app subscriptions. Buying on the website avoids it, and we pass part of the saving on to you.",
  },
  {
    question: "How do I unlock Pro in the app after paying on the website?",
    answer:
      "Use the same email at checkout as in your ReelMatch account. We email you a link that opens the app and links your purchase to your account. Pro then works on iPhone and Android.",
  },
  {
    question: "Can I cancel anytime?",
    answer:
      "Yes. Every receipt email includes a link to manage or cancel your subscription. You keep Pro until the end of the period you've paid for.",
  },
  {
    question: "What does ReelMatch Pro include?",
    answer:
      "Unlimited daily swipes, filtering by streaming provider, genre filters and instant TV launch. Swiping, watchlists, friends and matching stay free.",
  },
  {
    question: "Is the payment secure?",
    answer:
      "Yes. Payments are processed by Stripe. ReelMatch never sees or stores your card details.",
  },
  {
    question: "Do I need ReelMatch Pro to match with friends?",
    answer:
      "No. Matching is free for everyone, with 15 swipes a day on the free plan and bonus swipes when you invite friends. Pro is for people who want to swipe without limits and filter by service or genre.",
  },
];
